var mn_meal_number = 0;
var fattest_number = 0;
function handleIntersect(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (entry.intersectionRatio >= 1) {
        animateValue(entry.target, 0, mn_meal_number, 3000);
        observer.unobserve(entry.target);
      }
    }
  });
}
function createObserver(number_el, number_index) {
  var mn_int_obs = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: "0px",
    threshold: 1
  });
  number_el.innerHTML = '';
  number_el.innerText = '';
  var spacer = document.createElement('span');
  spacer.classList.add('a_s');
  spacer.innerText = new Intl.NumberFormat().format(fattest_number);
  number_el.appendChild(spacer);
  var animation_target = document.createElement('span');
  animation_target.classList.add('a_t');
  number_el.appendChild(animation_target);
  console.log('animation_target: ', animation_target);
  mn_int_obs.observe(animation_target);
}
function animateValue(obj, start, end, duration) {
  var start_timestamp = null;
  var anim_step = function(timestamp) {
    if (!start_timestamp) start_timestamp = timestamp;
    var progress = Math.min((timestamp - start_timestamp) / duration, 1);
    var anim_value = Math.floor(progress * (end - start) + start);
    obj.innerHTML = new Intl.NumberFormat().format(anim_value);
    if (progress < 1) {
      window.requestAnimationFrame(anim_step);
    }
  };
  window.requestAnimationFrame(anim_step);
}
function retrieveMeals() {
  fetch("https://try.noobru.com/api/meals-fortified").then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    return response.text();
  }).then((mf) => {
    if(mf) {
      mn_meal_number = mf
      // create the widest element bassed on the widdest possible number containing the same number of digits as the meals fortified number
      fattest_number = parseInt((''+mn_meal_number).split('').map((x, i) => i === 0 ? 2 : 0).join().replaceAll(',', ''));
      var meal_numbers = document.querySelectorAll('[data-meals-fortified] strong');
      for (var mn_i = 0; mn_i < meal_numbers.length; mn_i++) {
        createObserver(meal_numbers[mn_i], mn_i);
      }
    }
  });
}
document.addEventListener("DOMContentLoaded", (event) => retrieveMeals());